module.exports = __webpack_public_path__ + "img/header-diamondJewelryWhitegold@2x.ec5fd55.jpg";